import React from "react";
import Card from "../../../../offers/shared/AtomicCard";
import { css } from 'emotion';
import MyAccountNavItems from './MyAccountNavItems';
import { menu, menuList, pageTitle, helloUser } from './style';
import { ROUTE_ACCOUNT_DETAILS, ROUTE_HOME, ROUTE_MY_PASSENGERS, ROUTE_RANKING, ROUTE_SALE, ROUTE_ADVANCED_MANAGEMENT } from "../../shared/constants";
import { returnUserJWT } from "../../shared/utils";
import { ACCOUNT_FAMILY_EVENT } from "../../events/ga/events";

const ids = {
	myOffers: 'myOffers',
	mySells: 'mySells',
	rankingOffers: 'rankingOffers',
	myPassengers: 'myPassengers',
	registerData: 'registerData',
	familyCount: 'familyCount',
	smartExtract: 'smartExtract',
	logout: 'logout'
};

const addresses = [
	{
		icon: 'icon-max-finance-coupon',
		address: ROUTE_HOME,
		title: 'Minhas ofertas',
		dataAction: 'my-account-nav-items-my-offers',
		id: ids.myOffers
	},
	{
		icon: 'icon-max-finance-economy',
		address: ROUTE_SALE,
		title: 'Minhas vendas',
		dataAction: 'my-account-nav-items-my-sales',
		id: ids.mySells
	},
	{
		icon: 'icon-max-action-trophy',
		address: ROUTE_RANKING,
		title: 'Ranking de ofertas',
		dataAction: "my-account-nav-items-ranking",
		id: ids.rankingOffers
	},
	{
		icon: ' icon-max-travel-tickets',
		address: ROUTE_MY_PASSENGERS,
		title: 'Meus passageiros',
		dataAction: "my-account-nav-items-my-passengers",
		id: ids.myPassengers
	},
	{
		icon: 'icon-gear',
		address: ROUTE_ACCOUNT_DETAILS,
		title: 'Dados de cadastro',
		dataAction: "my-account-nav-items-account-details",
		id: ids.registerData
	},
	// {
	// 	icon: 'icon-gear',
	// 	address: ROUTE_SMART_EXTRACT,
	// 	onClick: () => (window.location.href = "/logout"),
	// 	dataAction: "my-account-nav-items-exit",
	// 	title: 'Extrato inteligente',
	//  id: ids.smartExtract
	// },
	{
		icon: 'icon-max-action-user',
		address: ROUTE_ADVANCED_MANAGEMENT,
		title: 'Conta família',
		dataAction: "my-account-nav-items-advanced-management",
		id: ids.familyCount,
		event_type: ACCOUNT_FAMILY_EVENT.button_main
	}
]

function Menu(props) {
	const { isSmallDevice, onClick } = props;
	const user = returnUserJWT();

	return (
		isSmallDevice ?
			// mobile and tablet
			<div className={css`${menuList}`}>
				<div className={css`${menu}`}>
					<MyAccountNavItems
						menuLinks={addresses}
						ids={ids}
						onClick={onClick}
					/>
				</div>
			</div>
			:
			// desktop
			<Card>
				<div className={css`${menuList}`}>
					<h1 className={css`${pageTitle}`}>Minha Conta</h1>
					<p className={css`${helloUser}`}>Olá, {user ? user.name.split(" ")[0] : "MaxMilhas"}!</p>
					<div className={css`${menu}`}>
						<MyAccountNavItems
							menuLinks={addresses}
							ids={ids} />
					</div>
				</div>
			</Card>
	);
}

export default Menu;
